import React, { useState, useEffect } from "react";
import "./PinGate.css";

const CORRECT_PIN = "2000"; // <-- CHANGE YOUR PIN HERE

export default function PinGate({ children }) {
  const [pin, setPin] = useState("");
  const [unlocked, setUnlocked] = useState(false);

  // Auto-login if pin saved locally
  useEffect(() => {
    const saved = localStorage.getItem("jobtracker_pin_ok");
    if (saved === "yes") setUnlocked(true);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pin === CORRECT_PIN) {
      setUnlocked(true);
      localStorage.setItem("jobtracker_pin_ok", "yes");
    } else {
      alert("Incorrect PIN");
      setPin("");
    }
  };

  if (unlocked) {
    return children;
  }

  return (
    <div className="pin-overlay">
      <div className="pin-box">
        <h2>Enter PIN to Access</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            className="pin-input"
            maxLength={6}
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            autoFocus
          />
          <button className="pin-btn">Unlock</button>
        </form>
      </div>
    </div>
  );
}
